export const API_KEY = "AIzaSyCn9iOf16lWPgunZn--vTiy6EZPiVuwnAY";

export default API_KEY